// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab-3uIn1","active":"active-7w0t5","title":"title-3Xs8m"};